import { render, staticRenderFns } from "./Software.vue?vue&type=template&id=9aeb467c&"
import script from "./Software.vue?vue&type=script&lang=ts&"
export * from "./Software.vue?vue&type=script&lang=ts&"
import style0 from "./Software.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VCard,VCardText,VCardTitle,VDivider})


/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9aeb467c')) {
      api.createRecord('9aeb467c', component.options)
    } else {
      api.reload('9aeb467c', component.options)
    }
    module.hot.accept("./Software.vue?vue&type=template&id=9aeb467c&", function () {
      api.rerender('9aeb467c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/Software.vue"
export default component.exports